(function(){
  document.querySelectorAll('.ddi-rv[id^="ddi-rv-"]').forEach(function(root){
  var currentHandle = root.getAttribute('data-current-handle');
  var KEY = 'ddi_recently_viewed_v1';
  var MAX_STORE = 12;
  var MAX_SHOW = 8;
  if (!currentHandle) return;

  function readList(){
    try{
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function(h){ return typeof h === 'string'; }) : [];
    }catch(e){ return []; }
  }
  function writeList(arr){
    try{ window.localStorage.setItem(KEY, JSON.stringify(arr)); }catch(e){}
  }
  function money(cents){
    if (typeof cents !== 'number') return '';
    var v = (cents/100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return '$' + s;
  }
  function escapeHtml(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  var list = readList().filter(function(h){ return h !== currentHandle; });
  list.unshift(currentHandle);
  if (list.length > MAX_STORE) list = list.slice(0, MAX_STORE);
  writeList(list);

  var others = list.filter(function(h){ return h !== currentHandle; }).slice(0, MAX_SHOW);
  if (!root) return;

  if (!others.length){
    document.dispatchEvent(new CustomEvent('ddi:rv:ready', { detail: { products: [] } }));
    return;
  }

  var row = root.querySelector('.ddi-rv__row');
  if (!row) return;

  Promise.all(others.map(function(h){
    return fetch('/products/' + encodeURIComponent(h) + '.js', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
  })).then(function(results){
    var cards = results.filter(Boolean);
    if (!cards.length){
      document.dispatchEvent(new CustomEvent('ddi:rv:ready', { detail: { products: [] } }));
      return;
    }

    cards.forEach(function(p){
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var priceMin = (typeof p.price_min === 'number') ? p.price_min : p.price;
      var compareAt = p.compare_at_price_min || p.compare_at_price || 0;
      var priceHtml = money(priceMin);
      if (compareAt && compareAt > priceMin){
        priceHtml = money(priceMin) + ' <del>' + money(compareAt) + '</del>';
      }
      var url = '/products/' + encodeURIComponent(p.handle);
      var li = document.createElement('li');
      li.className = 'ddi-rv__item';
      li.innerHTML =
        '<a class="ddi-rv__link" href="' + escapeHtml(url) + '" title="' + escapeHtml(p.title || '') + '">' +
          '<span class="ddi-rv__media">' +
            (img ? '<img loading="lazy" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title || '') + '" width="300" height="300">' : '') +
          '</span>' +
          '<span class="ddi-rv__name">' + escapeHtml(p.title || '') + '</span>' +
          '<span class="ddi-rv__price">' + priceHtml + '</span>' +
        '</a>';
      row.appendChild(li);
    });

    root.hidden = false;
    document.dispatchEvent(new CustomEvent('ddi:rv:ready', { detail: { products: cards } }));
  });
  });
})();
